export const PROCESSOR_DIRECTORY_FIXTURES = [
  {
    id: 'yona-1',
    name: 'Tolliver Deer Processing',
    town: 'Linden, AL',
    latitude: 32.3235,
    longitude: -87.8104,
    source: 'yona',
    via: null,
    phone: '(334) 555-0142',
    address: '1142 County Road 19, Linden, AL 36748',
    price_per_deer: '$95',
    turnaround: '7—10 days',
    cooler: 'Yes — 24 hr',
    takes: 'Deer · Hog',
    services: ['SKINNING', 'CUT SHEET', 'SAUSAGE', 'JERKY', 'CAPE FOR MOUNT'],
    notes: 'Cooler is round back with tags on the wall. Ray runs it himself through gun season and will pick up if you call before 8pm.',
    freshness: 'season',
    check_in_count: 34,
    recent_uses: [
      { initials: 'RT', text: 'Ray Tolliver dropped a doe here', when: '3 DAYS AGO', avatar_color: '#C08A20' },
      { initials: 'DH', text: 'Dale Hutto — cut sheet, summer sausage', when: '11 DAYS AGO', avatar_color: '#C9BF9B' },
      { initials: 'MK', text: 'Marlene Kirk confirmed they are taking deer', when: '2 WEEKS AGO', avatar_color: '#9BAE93' },
    ],
  },
  {
    id: 'yona-2',
    name: 'Black Belt Meat Co.',
    town: 'Demopolis, AL',
    latitude: 32.5182,
    longitude: -87.8364,
    source: 'yona',
    via: null,
    phone: '(334) 555-0198',
    address: '308 Highway 80 East, Demopolis, AL 36732',
    price_per_deer: '$120',
    turnaround: '14 days',
    cooler: 'Yes — walk-in',
    takes: 'Deer · Hog · Beef',
    services: ['SKINNING', 'CUT SHEET', 'SAUSAGE', 'SMOKED HAM', 'VACUUM SEAL'],
    notes: 'Full butcher shop, so deer go in the queue behind beef.',
    freshness: 'season',
    check_in_count: 21,
    recent_uses: [],
  },
  {
    id: 'yona-3',
    name: 'Sipsey Custom Cuts',
    town: 'Thomaston, AL',
    latitude: 32.2807,
    longitude: -87.6214,
    source: 'yona',
    via: null,
    phone: '(334) 555-0177',
    address: '55 Cedar Bottom Road, Thomaston, AL 36783',
    price_per_deer: '$80',
    turnaround: '5 days',
    cooler: 'No — hours only',
    takes: 'Deer only',
    services: ['SKINNING', 'CUT SHEET', 'GROUND'],
    notes: 'Small operation, one man and a walk-in.',
    freshness: 'stale',
    check_in_count: 9,
    recent_uses: [],
  },
  {
    id: 'yona-4',
    name: 'Whitfield Deer Cooler',
    town: 'Nanafalia, AL',
    latitude: 32.1131,
    longitude: -88.0042,
    source: 'yona',
    via: null,
    phone: '(334) 555-0155',
    address: '9 Landing Road, Nanafalia, AL 36764',
    price_per_deer: '$70 skinned',
    turnaround: '3—4 days',
    cooler: 'Yes — self serve',
    takes: 'Deer only',
    services: ['SKINNING', 'GROUND', 'QUARTERS'],
    notes: 'Drop and go cooler with an envelope box on the door.',
    freshness: 'stale',
    check_in_count: 12,
    recent_uses: [],
  },
  {
    id: 'yona-far',
    name: 'Prairie Cutters',
    town: 'Uniontown, AL',
    latitude: 32.9019,
    longitude: -87.7981,
    source: 'yona',
    via: null,
    phone: '(334) 555-0160',
    address: '1 Main Street, Uniontown, AL 36786',
    price_per_deer: '$90',
    turnaround: '10 days',
    cooler: 'Unknown',
    takes: 'Deer',
    services: ['SKINNING'],
    notes: '',
    freshness: 'none',
    check_in_count: 0,
    recent_uses: [],
  },
];
